import { readEveryoneSocialSettings } from './read'
import { updateEveryoneSocialSettings } from './update'

export const everyoneSocialSettings = {
  readCollection: readEveryoneSocialSettings,
  update: updateEveryoneSocialSettings,
}
